export type ProxyImplementationAddressDto = {
  proxyAddress: string;
  implementationAddress: string;
  standard: string;
};
